import React, { Fragment, useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as csidUtil from "../../components/csid/csid";
import { flowName, letsGetStartedFlowConfig, isBlackListedPartnerForNevigateYourDashboardLinkOnGetStarted } from "../../config/FlowName";
import { ezsServiceIds } from "../../config/UserServicesList";
import { ApplicationState } from "../../store";
import * as CSIDActions from "../../store/csid/actions";
import { ICSIDUserStatus } from "../../store/csid/types";
import * as NextStepFlowAction from "../../store/nextStepFlowService/actions";
import { useAreServicesActive } from "../../util/CommonServices";
import { DialogComponent } from "../common/DialogComponent";
import EZSCreditAuthentication from "../Credit/Auth/EZSCreditAuthentication";
import IDFCreditAuthentication from "../Credit/Auth/IDFCreditAuthentication";
import { CommonContext } from "../../CommonContextProvider";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const LetsGetStarted = (props: any) => {
    const { isLostWalletActive }: any = useContext(CommonContext);
    const isPrimaryAccount: boolean = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const isUserNotPermittedForGetStartedView: boolean = !isPrimaryAccount;
    const getFlowByName = (state: ApplicationState, flowName: string) => {
        if (state.nextStepFlowState && state.nextStepFlowState.userLetsGetStartedFlows) {
            const selectedFlow = state.nextStepFlowState.userLetsGetStartedFlows.find((flow) => flow.flowName === flowName);
            return selectedFlow;
        }
        return null;
    };
    const dispatch = useDispatch();
    const isFamilyProtectionServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionService]);
    const dismissAllItemFromStore = (flowType: string) => dispatch(NextStepFlowAction.actionCreators.dismissAllItem(flowType));
    const eZSChildSubscribers = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.eZSChildSubscribers ? state.familyServiceState.eZSChildSubscribers : []
    );
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const updateGetStartedUpdateStatus = () => dispatch(NextStepFlowAction.actionCreators.updateGetStartedUpdateStatus());
    const letsGetstartedFlowsInStore = useSelector((state: ApplicationState) =>
        state.nextStepFlowState && state.nextStepFlowState.userLetsGetStartedFlows ? state.nextStepFlowState.userLetsGetStartedFlows : []
    );
    const requestLetsGetStartedFlow = () => dispatch(NextStepFlowAction.actionCreators.requestLetsGetStartedFlow());
    const isGetStaredUpdatedInCurrentLoginSession = useSelector((state: ApplicationState) =>
        state.nextStepFlowState && state.nextStepFlowState.isGetStaredUpdatedInCurrentLoginSession
            ? state.nextStepFlowState.isGetStaredUpdatedInCurrentLoginSession
            : false
    );
    const downloadMobileApp = useSelector((state: ApplicationState) => getFlowByName(state, "DOWNLOAD-OUR-MOBILE-APP"));
    const financialAccountFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-FINANCIAL-ACCOUNTS"));
    const familyProtectionServiceFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-FAMILY-MEMBER"));
    const downloadCount = useSelector((state: ApplicationState) => (state.downloadAppState ? state.downloadAppState.numberOfAuthenticatedDevices : 0));
    const totalConnectedFinancialAccount = useSelector((state: ApplicationState) =>
        state.accountSummaryData && state.accountSummaryData.accountSummaryData && state.accountSummaryData.accountSummaryData.data
            ? state.accountSummaryData.accountSummaryData.data.length
            : 0
    );
    const shouldDownloadMobileAppBeCompleted = () => {
        return downloadCount && downloadCount > 0 && downloadMobileApp && downloadMobileApp.flowStepStatus !== "COMPLETED";
    };
    const shouldFiancialAccountBeCompleted = () => {
        return totalConnectedFinancialAccount && totalConnectedFinancialAccount > 0 && financialAccountFlow && financialAccountFlow.flowStepStatus !== "COMPLETED";
    };
    const shouldFamilyProtectionServiceBeCompleted = () => {
        return (
            isFamilyProtectionServiceActive &&
            eZSChildSubscribers.length > 0 &&
            familyProtectionServiceFlow &&
            familyProtectionServiceFlow.flowStepStatus !== "COMPLETED"
        );
    };
    const getUserCSIDStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus());
    const isLoading = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.isLoading ? state.csidUserStatusState.isLoading : false
    );
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );
    const refreshContext = () => dispatch(CSIDActions.actionCreators.componentNeedsRefresh());
    const [isSSNPinning, setIsSSNPinning] = useState(true);
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isPasswordsAvailable = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isPasswordsAvailable
            ? state.configurationState.configuration.partnerConfig.isPasswordsAvailable
            : false
    );

    if (shouldFiancialAccountBeCompleted()) {
        if (financialAccountFlow) {
            completeGetStartedItem(financialAccountFlow.flowStepId, financialAccountFlow.flowName ? financialAccountFlow.flowName : " ");
        }
    }

    if (shouldDownloadMobileAppBeCompleted()) {
        if (downloadMobileApp) {
            completeGetStartedItem(downloadMobileApp.flowStepId, downloadMobileApp.flowName ? downloadMobileApp.flowName : " ");
        }
    }

    if (shouldFamilyProtectionServiceBeCompleted()) {
        if (familyProtectionServiceFlow) {
            completeGetStartedItem(familyProtectionServiceFlow.flowStepId, familyProtectionServiceFlow.flowName ? familyProtectionServiceFlow.flowName : " ");
        }
    }

    const [showCreditAuth, setShowCreditAuth] = useState(false);

    const creditMonitoringAndPublicServiceList = [
        ezsServiceIds.creditMonitoring,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.oneBureauQuarterlyCreditReport,
        ezsServiceIds.oneBureauMonthlyCreditReport,
        ezsServiceIds.financialAccountMonitoring,
        ezsServiceIds.financialTransactionMonitoringMX,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuEnhancedCreditAlerts,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.threeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        // ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaCreditMonitoring,
    ];
    const isCreditMonitoringActive = useAreServicesActive(creditMonitoringAndPublicServiceList);

    const ezsCreditAuthSuccessCallBack = (callbackObj: any) => {
        requestLetsGetStartedFlow();
        getUserCSIDStatus();
        setShowCreditAuth(false);
        refreshContext();
    };

    useEffect(() => {
        getUserCSIDStatus();
        requestLetsGetStartedFlow();
    }, []);

    useEffect(() => {
        if (csidUserStatus && csidUserStatus.csidActivationStatus) {
            const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus as ICSIDUserStatus);
            if (nextStep === csidUtil.NEXT_STEP.GO_TO_DASHBOARD) {
                setIsSSNPinning(false);
            } else {
                setIsSSNPinning(true);
            }
        }
    }, [csidUserStatus]);

    let letsGetstartedFlows = letsGetstartedFlowsInStore;

    if (letsGetstartedFlows.length <= 0) {
        return <Fragment></Fragment>;
    }

    const lostWalletFlowName = "LOST-WALLET-ASSISTANCE";
    const isLostWalletExistsInGetStartedFlow = letsGetstartedFlowsInStore.find(function (item) {
        if (item.flowName === lostWalletFlowName) return true;
        return false;
    });

    const passwordManagerFlowName = "CHECK-OUT-YOUR-PASSWORD-MANAGER";
    const isPasswordManagerExistsInGetStartedFlow = letsGetstartedFlowsInStore.find(function (item) {
        if (item.flowName === passwordManagerFlowName) return true;
        return false;
    });

    // remove redit score and credit report
    const reviewCreditScore = "REVIEW-YOUR-CREDIT-SCORE";
    const reviewCreditReport = "REVIEW-YOUR-CREDIT-REPORT";

    const hasCreditScoreFlow = letsGetstartedFlowsInStore.find(function (item) {
        if (item.flowName === reviewCreditScore) return true;
        return false;
    });
    const hasCredirReportFlow = letsGetstartedFlowsInStore.find(function (item) {
        if (item.flowName === reviewCreditReport) return true;
        return false;
    });

    if (hasCredirReportFlow) {
        letsGetstartedFlows = letsGetstartedFlows.filter(function (element) {
            return element.flowName !== reviewCreditReport;
        });
    }

    if (hasCreditScoreFlow) {
        letsGetstartedFlows = letsGetstartedFlows.filter(function (element) {
            return element.flowName !== reviewCreditScore;
        });
    }

    if (isLostWalletExistsInGetStartedFlow && !isLostWalletActive) {
        letsGetstartedFlows = letsGetstartedFlows.filter(function (element) {
            return element.flowName !== lostWalletFlowName;
        });
    }

    if (isPasswordManagerExistsInGetStartedFlow && !isPasswordsAvailable) {
        letsGetstartedFlows = letsGetstartedFlows.filter(function (element) {
            return element.flowName !== passwordManagerFlowName;
        });
    }

    const isNevigateYourDashboardFlowExists = letsGetstartedFlowsInStore.find(function (item) {
        if (item.flowName === flowName.NAVIGATING_YOUR_DASHBOARD) return true;
        return false;
    });

    if (isBlackListedPartnerForNevigateYourDashboardLinkOnGetStarted(partnerID) && isNevigateYourDashboardFlowExists) {
        letsGetstartedFlows = letsGetstartedFlows.filter(function (element) {
            return element.flowName !== flowName.NAVIGATING_YOUR_DASHBOARD;
        });
    }

    letsGetstartedFlows = letsGetstartedFlows.slice(0, 5);

    const getCompletionPercentage = () => {
        const totalNumberOfMessage = letsGetstartedFlows.length;
        let completedMessagedCount = letsGetstartedFlows.filter((obj) => obj.flowStepStatus === "COMPLETED").length;

        let createYourProfileFlow = letsGetstartedFlows.find((obj) => {
            return obj.flowName === flowName.createYourProfile;
        });

        if (createYourProfileFlow && createYourProfileFlow.flowStepStatus !== "COMPLETED") {
            completedMessagedCount++;
        }

        const completionPercentage = Math.floor((100 * completedMessagedCount) / totalNumberOfMessage);

        return completionPercentage + "%";
    };

    const handelClickEvent = (flowConfig: any, getStartedFlow: any) => {
        window.addToDataLayer({ event: flowConfig.eventName });
        if (flowConfig.link) {
            if (flowConfig.isLinkCompletion) {
                completeGetStartedItem(getStartedFlow.flowStepId, getStartedFlow.flowName);
            }
            props.history.push(flowConfig.link);
        } else if (flowConfig.flowName === "ADD-FAMILY-MEMBER" && isFamilyProtectionServiceActive && eZSChildSubscribers.length <= 0) {
            props.openAddFamilyProtectionDialog();
        } else if (flowConfig.flowName === "NAVIGATING-YOUR-DASHBOARD") {
            completeGetStartedItem(getStartedFlow.flowStepId, getStartedFlow.flowName);
            props.openDashboardVideoDialog();
        }
    };

    const isFlowCompleted = (flow: any) => {
        if (flow && ((flow.flowStepStatus && flow.flowStepStatus === "COMPLETED") || (flow.flowName && flow.flowName === flowName.createYourProfile))) {
            return true;
        }
        return false;
    };

    const getCompletedFlowView = (flow: any) => {
        return (
            <a style={{ cursor: "default" }} tabIndex={0} className="onboarding-task-container status-complete" role="link">
                <span className="onboarding-task-icon">
                    <em className="las la-check-circle"></em>
                </span>
                <span className="onboarding-task-text">
                    <p className="onboard-task-title" style={{ textDecoration: "none" }}>
                        {flow.flowDescription}
                    </p>
                    <p>{flow.flowStepName}</p>
                </span>
            </a>
        );
    };

    const getNotCompletedFlowView = (flow: any, flowConfig: any) => {
        return (
            <a
                style={{ cursor: "pointer" }}
                tabIndex={0}
                onClick={() => handelClickEvent(flowConfig, flow)}
                onKeyDown={(e) => e.key == "Enter" && handelClickEvent(flowConfig, flow)}
                className="onboarding-task-container"
                role="link"
            >
                <span className="onboarding-task-icon">
                    <RenderIcons height="22" width="24" color="#4A4A4A " iconName={`${flowConfig.logo}`} />
                </span>
                <span className="onboarding-task-text">
                    <p className="onboard-task-title">{flow.flowDescription}</p>
                    <p>{flow.flowStepName}</p>
                </span>
            </a>
        );
    };

    const renderFlowMessage = (flow: any) => {
        let flowConfig: any;
        if (flow.flowName) {
            const findFlowConfig = letsGetStartedFlowConfig.find((obj) => {
                return obj.flowName === flow.flowName;
            });
            flowConfig = Object.assign({}, findFlowConfig);
        }
        if (flowConfig && (flowConfig.flowName === "REVIEW-YOUR-CREDIT-SCORE" || flowConfig.flowName === "REVIEW-YOUR-CREDIT-REPORT")) {
            if (isCreditMonitoringActive === false) {
                flowConfig = null;
            } else {
                if (isSSNPinning === true) {
                    flowConfig.logo = "las la-exclamation-triangle";
                    flowConfig.link = "";

                    flow.flowDescription = "Authenticate Your Identity";
                    flow.flowStepName = "We need more information to complete your enrollment in your credit monitoring service.";
                }
            }
        }

        if (!flowConfig) {
            return <Fragment></Fragment>;
        }

        return <li key={flow.flowName}>{isFlowCompleted(flow) ? getCompletedFlowView(flow) : getNotCompletedFlowView(flow, flowConfig)}</li>;
    };

    const completionPercentage = getCompletionPercentage();

    const dismissAllItem = (event: any) => {
        if (event.type === "click" || (event.type === "keydown" && (event.key === " " || event.key === "Enter"))) {
            const flow = letsGetstartedFlows.length > 0 ? letsGetstartedFlows[0] : null;
            const flowType = flow && flow.flowTypeName ? flow.flowTypeName : "";
            window.addToDataLayer({ event: "Skip Lets Get Started" });
            dismissAllItemFromStore(flowType);
        }
    };

    if (!isGetStaredUpdatedInCurrentLoginSession && completionPercentage !== "100%" && letsGetstartedFlows.length > 0) {
        updateGetStartedUpdateStatus();
    }

    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowCreditAuth(false);
        refreshContext();
    };

    if (isUserNotPermittedForGetStartedView) {
        return <Fragment></Fragment>;
    }

    return (
        <Fragment>
            {!isGetStaredUpdatedInCurrentLoginSession && completionPercentage === "100%" ? (
                <Fragment></Fragment>
            ) : (
                <Fragment>
                    <div className="box">
                        {!isLoading ? (
                            <>
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-text has-actions">
                                            <h2 className="box-title heading-title">{tLang("dashboard.letGetStartedWidget.title")}</h2>
                                        </div>
                                    </div>
                                    <div className="box-actions">
                                        <span id="onboarding-status-complete">{completionPercentage}</span> {tLang("dashboard.letGetStartedWidget.complete")}
                                    </div>
                                    <div className="box-helper">
                                        <div id="onboard-progress" className="onboard-progress-track">
                                            <div className="onboard-progress-value" style={{ width: completionPercentage }}></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <ul className="list-reset" id="onboarding-task-list">
                                        {letsGetstartedFlows.map((flow) => renderFlowMessage(flow))}
                                    </ul>
                                    <div className="text-align-right">
                                        <a
                                            style={{ cursor: "pointer" }}
                                            tabIndex={0}
                                            onClick={dismissAllItem}
                                            onKeyDown={dismissAllItem}
                                            className="default_link skip_action"
                                            role="link"
                                        >
                                            {completionPercentage === "100%" ? tLang("hide.title") : tLang("dashboard.letGetStartedWidget.skip")}
                                            <span className="sr-only">Onboarding Tasks</span>
                                        </a>
                                    </div>
                                </div>
                                {showCreditAuth && csidUserStatus && (
                                    <DialogComponent
                                        dialogId="dialog-l3-disclosure"
                                        title="L3 Disclosure"
                                        closeDialog={closeDisclosureDialogCallBack}
                                        hideCloseButton={false}
                                    >
                                        <div className="dialog-body">
                                            {csidUserStatus.l3AuthProvider.isTU || csidUserStatus.l3AuthProvider.isIDF ? (
                                                <IDFCreditAuthentication
                                                    initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                                    creditAuthCallback={ezsCreditAuthSuccessCallBack}
                                                    displayFlowAsDialog={true}
                                                />
                                            ) : (
                                                <EZSCreditAuthentication
                                                    initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                                    creditAuthCallback={ezsCreditAuthSuccessCallBack}
                                                    displayFlowAsDialog={false}
                                                    onCloseCallback={closeDisclosureDialogCallBack}
                                                    l3Case={"credit-service"}
                                                    componentParent={"dashboard"}
                                                />
                                            )}
                                        </div>
                                    </DialogComponent>
                                )}
                            </>
                        ) : (
                            <div className="loading"></div>
                        )}
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

export default LetsGetStarted;
